import React, { useEffect } from "react";
import { Button, Box, Drawer, Stack, SwipeableDrawer, Typography, Collapse } from "@mui/material";

import ClientCrumb from "../../App/assets/images/ClientCrumb.png"
import ScenarioCrumb from "../../App/assets/images/ScenarioCrumb.png"
import { TopOffset } from "../../App/Navbar_bs";
import QuickStartIcon from "../../Components/QuickIcon";
import { CollapseAdd } from "../../App/CollapseButtons";


export const Starter = ({ show, onClose, width }) => {



  // <Drawer
  //         key="starter-drawer"
  //         disableEnforceFocus
  //         hideBackdrop
  //         sx={{ minHeight: 300, maxHeight: 1000 }}
  //         style={{ overflow: "scroll", pointerEvents: 'none', minHeight: 300, maxHeight: 1000 }}
  //         PaperProps={{ style: { backgroundColor: "#dddddd", pointerEvents: 'auto' } }}
  //         anchor="bottom" open={getHelp()} >


  return (

    <Drawer anchor="right" open={show} variant="persistent" onClose={onClose}
      sx={{
        width: width,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: width,
          boxSizing: 'border-box',
        },
      }}>

      <Box
        // textAlign="left"
        variant="permanent"
        //maxWidth={width}
        sx={{
          m: 2, p: 2,
          mt: TopOffset,
          overflow: "scroll",
          border: "2px solid #17be34",
          justifyContent: "flex-start",
          display: "flex,",
          textAlign: "left"
        }}
      >
        <Stack spacing={1}>
          <Box sx={{
            display: "flex"
          }}>
            <Typography variant="h5" gutterBottom>
              Startup
            </Typography>
            <Box sx={{ display: "flex", flexGrow: 1, justifyContent: "flex-end" }}>
              <Button onClick={onClose} variant="contained">
                Dismiss
              </Button>
            </Box>
          </Box>


          <Typography variant="body" gutterBottom={false}>
            <li><b>Create a client:</b> If you have no personal clients the Quick Start show automatically. Use that to quickly enter your first of information for your first client.<br />
              You can either select the quick start or regular adding of clients.  </li>
          </Typography>
          <Stack direction="row" spacing={4}>
            <QuickStartIcon onClick={() => { }} />
            <Typography variant="body" gutterBottom={false}>
              <b>QuickStart:</b>This allows you to quickly enter the basics for a new client. It will automatically setup a typical of accounts and their defaults, based on the entries
            </Typography>
          </Stack>
          <Stack direction="row" spacing={8}>
            <CollapseAdd onClick={() => { }} />
            <Typography variant="body" gutterBottom={false}>
              <b>Add Client:</b>This allows you to enter all the information for a new client. Enter at least <i>Date of Birth, First Name, Tax Jurisdictions</i>  You can then setup accounts in a later step.
            </Typography>
          </Stack>

          <Typography variant="body" gutterBottom>
            <li><b>Public Client:</b>  Clients/ Public Clients -> select a public client.  These are clients that show off certain attributes of the system.  Note: You can (but don't have to) copy the public client to your personal set of clients and make limited modifications to that new copied personal client.  If you just select the public client, you will only be able to views its current accounts/scenarios and its grids/charts.</li>
            <img src={ClientCrumb} style={{ m: -5, p: -5, transform: "scale(1.0)" }} /> will show up on the upper left indicating the active client.<br />
            <br />
            <b>Create Accounts</b>
            <li><b>Add Accounts:</b>  Go to accounts and add a few accounts to start (Employment, Expenses, NonReg (Cash), TFSA, RRSP).  Add in the values from Dec 31 last year.  You can add more later.  </li>
            <br />
            <b>Run the Scenario</b><br />
            Now you are on the scenario Grid, from here you can <br />
            <ul>
              <li><b>View detail grids.</b></li>
              <li><b>View Charts</b></li>
              <li><b>Adjust OAS/CPP (under Accounts or when you run the Scenario).</b></li>
              <li><b>Add/Edit more Accounts (under Accounts)</b></li>
              <li><b>Edit Saving/Income Rules to tailor the behaviour</b></li>
              <li><b>Run a Sweep</b></li>
            </ul>
            <b>Compare scenarios</b><br />
            Once you have a few scenarios you can compare them from the Scenario selection screen <br /><br />



            <img src={ScenarioCrumb} style={{ m: -5, p: -5, transform: "scale(1.0)" }} /> will show up on the upper left showing the active scenario.  <b><i>NOTE: when the scenario crumb is shown, any changes will be made against the scenario and not the base client.</i></b>  You can click that red button off OR later you can copy the data from the scenario to the base client at any time.<br />

            <br />

            <b>Help:</b> A green help icon on the screen that you can click to give you more information on a given screen.<br />
            <b>User Guide:</b> Read the more comprehensive User Guide (top right)<br />
            <b>News:</b> Read up on the latest updates (top right)<br />
            <b>Suggestion:</b> Browse/Add/Vote/Comment on suggested improvements (top right)<br />
          </Typography>
        </Stack>
      </Box>
    </Drawer >
  );
};


